export default __webpack_public_path__ + "9b2e6ebf4fe7c9ec3ab9921f7f9ccaf9.png";